// Fundraisers v2 is behind a beta flag for clients (VITE_FUNDRAISER_BETA).
//
// Admins — HHL staff who open a campaign in the client app via a `?campaignId=`
// URL param, which sets `AdminContext.isAdmin` — always get v2 access so they
// can build and edit v2 fundraisers on production before the public launch,
// without the client seeing them.
//
// TODO(fundraisers-v2 launch): when v2 goes live for everyone, set
// VITE_FUNDRAISER_BETA=true in every env and delete this helper along with the
// `isAdmin` fallback below. See GO_LIVE.md.
export const FUNDRAISER_BETA = import.meta.env.VITE_FUNDRAISER_BETA === 'true';

/**
 * Whether the Fundraisers v2 experience should be available to the current user.
 * True when the beta flag is on for the environment, or when the viewer is an
 * HHL admin accessing the campaign from the admin app.
 */
export const fundraiserV2Enabled = (isAdmin?: boolean): boolean =>
    FUNDRAISER_BETA || Boolean(isAdmin);
